// removed by extract-text-webpack-plugin
module.exports = {"description":"_2j3ht9Wc9xGm0j1Tz42gnU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AlbumThumbDescrition/AlbumThumbDescrition.scss
// module id = 1243
// module chunks = 1